module.exports = "<router-outlet></router-outlet>\r\n<vit-info-bubble *ngIf=\"sessionService.showInfoBubbleSuccess || sessionService.showInfoBubbleError\"></vit-info-bubble>\r\n<vit-jackpot-bubble *ngIf=\"sessionService.showJackpotWon\"></vit-jackpot-bubble>"


//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1